import Nationality from '@/api/hr/nationality'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        ...context.state.queryBuilder
      },
      attributes
    )

    return Nationality.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return Nationality.store(data)
  },

  update(context, { id, ...data }) {
    return Nationality.update(id, data)
  },

  destroy(context, id) {
    return Nationality.destroy(id).then(response => {
      return Promise.resolve(response)
    })
  }
}
